import React from 'react';
import { Link } from 'gatsby'

export default function Pagination({ pageContext }) {
  const { previousPagePath, nextPagePath, humanPageNumber, numberOfPages } = pageContext
  const pageNumbersToShow = 5;
  const base = previousPagePath || nextPagePath;

  let basePath = '/';
  basePath = base.substring(0, base.indexOf('/seite'));
  if (basePath == '') {
    basePath = '/blog/';
  }

  let startPage = Math.max(1, humanPageNumber - pageNumbersToShow);
  let endPage = Math.min(numberOfPages, humanPageNumber + pageNumbersToShow);

  const idealRangeSize = pageNumbersToShow * 2 + 1;
  if (endPage - startPage + 1 < idealRangeSize) {
    if (humanPageNumber <= pageNumbersToShow) {
      endPage = Math.min(numberOfPages, idealRangeSize);
    } else if (humanPageNumber > numberOfPages - pageNumbersToShow) {
      startPage = Math.max(1, numberOfPages - idealRangeSize + 1);
    }
  }

  startPage = Math.max(1, startPage);
  endPage = Math.min(numberOfPages, endPage);

  const pageNumbers = [];
  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  const getPagePath = (page) => {
    if (page === 1) {
      return basePath;
    }
    const normalizedBasePath = basePath.endsWith('/') ? basePath.slice(0, -1) : basePath;
    return `${normalizedBasePath}/seite/${page}`;
  };

  return (
    <nav className="pagination container container--wide" role="navigation">
      {/* back */}
      {previousPagePath ? (
        <Link className="button" to={previousPagePath} rel="prev" style={{ marginRight: '10px' }}>
          zurück
        </Link>
      ) : (
        <span className="button disabled" style={{ marginRight: '10px', opacity: 0.6, cursor: 'not-allowed' }}>
          zurück
        </span>
      )}

      {/* Page Numbers */}
      {numberOfPages > 1 && (
        <ul>
          {pageNumbers.map((page) => (
            <li key={page}>
              {page === humanPageNumber ? (
                <span className="button current-page">
                  {page}
                </span>
              ) : (
                <Link
                  className="button"
                  to={getPagePath(page)} // Use the helper function here
                  style={{ textDecoration: 'none' }}
                >
                  {page}
                </Link>
              )}
            </li>
          ))}
        </ul>
      )}

      {/* next */}
      {nextPagePath ? (
        <Link className="button" to={nextPagePath} rel="next" style={{ marginLeft: '10px' }}>
          weiter
        </Link>
      ) : (
        <span className="button disabled" style={{ marginLeft: '10px', opacity: 0.6, cursor: 'not-allowed' }}>
          weiter
        </span>
      )}
    </nav>
  );
}
